t = require('views/internal/teacup-with-helpers')('popover_limit_exceeded')

module.exports = t.renderable ->
  t.div '.error.js-limit-exceeded', { style: "margin: 12px 0 6px;" }, ->
    t.format 'attachments-per-card-exceeded'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_limit_exceeded.coffee